import { render, staticRenderFns } from "./ContactDetailsNotePhoneTextField.vue?vue&type=template&id=06330eda"
import script from "./ContactDetailsNotePhoneTextField.vue?vue&type=script&lang=ts"
export * from "./ContactDetailsNotePhoneTextField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports